import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { fadeInUpAnimation } from 'src/@omnial/_animations/fade-in-up.animation';
import { Topic } from 'src/@omnial/_models/catalog/topic.model';
import { TopicService } from 'src/@omnial/_services/catalog/topic.service';

@Component({
    selector: 'app-topic-content',
    templateUrl: './../../../app/shared/topic-content/topic-content.component.html',
    styleUrls: ['./../../../app/shared/topic-content/topic-content.component.scss'],
    animations: [fadeInUpAnimation],
    standalone: false
})
export class TopicContentComponent implements OnInit {
  @Input() topicSlug: string;
  @Input() marginTop: boolean = false;
  @Input() marginBottom: boolean = false;
  @Input() marginLeft: boolean = false;
  @Input() marginRight: boolean = false;
  public topic: Topic;
  public topicClass: string;

  constructor(
    public topicService: TopicService,
    public router: Router) { }

  ngOnInit(): void {
    this.topicService.getTopicBySlug(this.topicSlug).subscribe(
      res => {
        if (res) {
          this.topic = res as Topic;
        }
      });
    this.topicClass = "topic-content nop-content";
    if (this.marginTop) {
      this.topicClass += " mt-1";
    }
    if (this.marginBottom) {
      this.topicClass += " mb-1";
    }
    if (this.marginLeft) {
      this.topicClass += " ml-1";
    }
    if (this.marginRight) {
      this.topicClass += " mr-1";
    }
  }
}
